<template>
  <div class="page1">
    <div class="datas">
      <img src="~assets/img/mobile/img_6.jpg" alt="" />
      <div class="text">牡丹诗词</div>
    </div>
    <div class="con">
      <ul class="pics">
        <li v-for="(item, index) in pics">
          <img v-lazy="item" alt="" @click="openPicss(index)">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pics:[]
    };
  },
  created() {
    for (let index = 1; index <= 173; index++) {
      this.pics.push(require('assets/img/culture/shici/'+ index + '.jpg'))
    }
  },

  methods: {
    openPicss(num) {
      this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: num,
        imgList: this.pics
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.page1 {
  .datas {
    width: 100%;
    margin-bottom: 4vw;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .text {
      color: #fff;
      font-family: "sycn";
      font-size: 4.8vw;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .con {
    .pics {
      padding: 2.6667vw;
      width: 100%;
      li {
        margin-bottom: 2.6667vw;
        img {
          width: 100%;
          display: block;
        }
      }
    }
  }
}
</style>